import React, { useState } from "react";
import styles from "./styles/Events.module.css";
import Modal from "./Modal";
import ModalSecond from "./ModalSecond";
import { Container, Row, Col, Card } from "react-bootstrap";

const Events = () => {
  const [isClicked, setIsClicked] = useState(false);
  const [clickedImage, setClickedImage] = useState("");

  const handleClick = (src) => {
    setIsClicked(true);
    setClickedImage(src);
  };

  const handleClose = () => {
    setIsClicked(false);
    setClickedImage("");
  };

  return (
    <div className={styles.background}>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <Container>
        <Row>
          <Col>
            <h1 className={styles.eventsHeader}>
              <b>Events</b>
            </h1>
            <hr className={styles.divider} />
          </Col>
        </Row>
        <Row>
          {/* <h6 className="text-center">Click to enlarge</h6> */}
          <Col xs={12} sm={12} md={12} lg={12}>
            <div className={styles.eventScheduleWrapper}>
              <Card className={styles.eventSchedule}>
                <Card.Img
                  variant="top"
                  // onClick={() =>
                  //   handleClick("imgs/event_schedule_park_closing.png")
                  // }
                  className={styles.eventsImg}
                  src="imgs/event_schedule_park_closing.png"
                  alt="Calendar for Plymouth Shore"
                  data-bs-toggle="modal"
                  data-bs-target="#eventsModal2"
                />
              </Card>
            </div>
          </Col>
        </Row>

        {/* <Modal /> */}
        <ModalSecond />
        {/* <Row>
					<Col xs={12} sm={12} md={12} lg={12}>
						<div className={styles.eventScheduleWrapper}>
							<Card className={styles.eventSchedule}>
								<Card.Img
									variant='top'
									// onClick={() =>
									// 	handleClick('imgs/event_calendar_updated_2.png')
									// }
									className={styles.eventsImg}
									src='imgs/event_calendar_updated_2.png'
									alt='Calendar for Plymouth Shore'
									data-bs-toggle='modal'
									data-bs-target='#eventsModal2'
								/>
							</Card>
						</div>
					</Col>
				</Row> */}
      </Container>

      {isClicked && (
        <div className={styles.overlay} onClick={handleClose}>
          <img
            src={clickedImage}
            alt="Enlarged "
            className={styles.enlargedImage}
          />
        </div>
      )}
    </div>
  );
};

export default Events;
